import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createBlock(_component_BaseDialog, {
    dialog: $props.dialog,
    title: _ctx.$t('dialogs.import.title'),
    onClose: $options.closeModal,
    onSumbitData: $options.importContacts
  }, {
    dataFields: _withCtx(() => [
      _createVNode(_component_v_textarea, {
        modelValue: $data.jsonData,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.jsonData) = $event)),
        modelModifiers: { trim: true },
        rules: $data.jsonDataRules,
        label: _ctx.$t('dialogs.import.inputTitle'),
        "auto-grow": "",
        required: "",
        "persistent-hint": "",
        hint: _ctx.$t('dialogs.import.hint'),
        class: "pb-2"
      }, null, 8, ["modelValue", "rules", "label", "hint"])
    ]),
    mainAction: _withCtx(() => [
      _createVNode(_component_v_btn, {
        variant: "outlined",
        color: "blue",
        type: "submit",
        disabled: !$options.hasEnteredData
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            small: "",
            class: "mr-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-application-import")
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('dialogs.import.btnTitle')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["dialog", "title", "onClose", "onSumbitData"]))
}